import type { ManageDataIconProps } from './helpers';

export const ManageDataIcon = ({ variant = 'edit', title, ...rest }: ManageDataIconProps) => {
	if (variant === 'edit') {
		return (
			<svg
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				{title && <title>{title}</title>}
				<rect
					width='24'
					height='24'
					rx='12'
					fill='#F7F8F8'
				/>
				<path
					opacity='0.4'
					d='M17.25 17.832H6.75C6.51083 17.832 6.3125 17.6337 6.3125 17.3945C6.3125 17.1554 6.51083 16.957 6.75 16.957H17.25C17.4892 16.957 17.6875 17.1554 17.6875 17.3945C17.6875 17.6337 17.4892 17.832 17.25 17.832Z'
					fill='#748181'
				/>
				<path
					opacity='0.4'
					d='M16.0947 7.0316C14.9631 5.89993 13.8547 5.87076 12.6939 7.0316L11.9881 7.73743C11.9297 7.79576 11.9064 7.8891 11.9297 7.97076C12.3731 9.5166 13.6097 10.7533 15.1556 11.1966C15.1789 11.2024 15.2022 11.2083 15.2256 11.2083C15.2897 11.2083 15.3481 11.1849 15.3947 11.1383L16.0947 10.4324C16.6722 9.86076 16.9522 9.3066 16.9522 8.7466C16.9581 8.1691 16.6781 7.6091 16.0947 7.0316Z'
					fill='#748181'
				/>
				<path
					d='M14.106 11.724C13.9368 11.6423 13.7735 11.5607 13.616 11.4673C13.4876 11.3915 13.3651 11.3098 13.2426 11.2223C13.1435 11.1582 13.0268 11.0648 12.916 10.9715C12.9043 10.9657 12.8635 10.9307 12.8168 10.884C12.6243 10.7207 12.4085 10.5107 12.216 10.2773C12.1985 10.2657 12.1693 10.2248 12.1285 10.1723C12.0701 10.1023 11.971 9.98568 11.8835 9.85151C11.8135 9.76401 11.7318 9.63568 11.656 9.50734C11.5626 9.34984 11.481 9.19234 11.3993 9.02901C11.3176 8.85401 11.2535 8.68484 11.1951 8.52734L7.53181 12.1907C7.45598 12.2665 7.38598 12.4123 7.36848 12.5115L7.05348 14.7457C6.99515 15.1423 7.10598 15.5157 7.35098 15.7665C7.56098 15.9707 7.85265 16.0815 8.16765 16.0815C8.23765 16.0815 8.30765 16.0757 8.37765 16.064L10.6176 15.749C10.7226 15.7315 10.8685 15.6615 10.9385 15.5857L14.6018 11.9223C14.4385 11.864 14.281 11.7998 14.106 11.724Z'
					fill='#748181'
				/>
			</svg>
		);
	}

	if (variant === 'copy') {
		return (
			<svg
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				{title && <title>{title}</title>}
				<rect
					width='24'
					height='24'
					rx='12'
					fill='#F7F8F8'
				/>
				<path
					d='M14.3333 12.5263V14.9763C14.3333 17.018 13.5166 17.8346 11.475 17.8346H9.02496C6.98329 17.8346 6.16663 17.018 6.16663 14.9763V12.5263C6.16663 10.4846 6.98329 9.66797 9.02496 9.66797H11.475C13.5166 9.66797 14.3333 10.4846 14.3333 12.5263Z'
					fill='#748181'
				/>
				<path
					opacity='0.4'
					d='M14.975 6.16797H12.525C10.5125 6.16797 9.69582 6.96714 9.67249 8.9388H11.475C13.925 8.9388 15.0625 10.0763 15.0625 12.5263V14.3288C17.0342 14.3055 17.8333 13.4888 17.8333 11.4763V9.0263C17.8333 6.98464 17.0167 6.16797 14.975 6.16797Z'
					fill='#748181'
				/>
			</svg>
		);
	}

	return (
		<svg
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			{title && <title>{title}</title>}
			<rect
				width='24'
				height='24'
				rx='12'
				fill='#FAE0E0'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M16.7104 8.36799H14.2948C14.2709 7.98649 14.1653 7.44866 13.7856 7.01232C13.3842 6.55091 12.7834 6.31641 11.9994 6.31641C11.216 6.31641 10.6151 6.55091 10.2138 7.01232C9.83405 7.44866 9.72788 7.98649 9.70397 8.36799H7.28955C7.04805 8.36799 6.85205 8.56399 6.85205 8.80549C6.85205 9.04699 7.04805 9.24299 7.28955 9.24299H16.7104C16.9519 9.24299 17.1479 9.04699 17.1479 8.80549C17.1479 8.56399 16.9519 8.36799 16.7104 8.36799Z'
				fill='#C11F1E'
			/>
			<path
				opacity='0.4'
				fillRule='evenodd'
				clipRule='evenodd'
				d='M16.1409 10.5964C16.1409 10.4354 16.0102 10.3047 15.8492 10.3047H8.15157C7.98999 10.3047 7.8599 10.4354 7.8599 10.5964C7.8599 11.1779 7.8494 11.7199 7.83949 12.2221C7.79632 14.409 7.76774 15.8539 8.65149 16.7552C9.27915 17.3951 10.3099 17.6809 11.994 17.6809C13.6798 17.6809 14.7123 17.3945 15.3417 16.7534C16.2296 15.8481 16.2016 14.3962 16.1602 12.197C16.1508 11.7018 16.1409 11.168 16.1409 10.5964Z'
				fill='#C11F1E'
			/>
		</svg>
	);
};
